import { call, put, select, take, delay } from "redux-saga/effects";
import getDevicesPromise from '@/services/tradeIn/getDevices';
import { actions, types } from '@/reducers/devices'

export const normalizeGetDevicesResponse = (data) => {
  const { results: devices } = { ...data };
  if (Array.isArray(devices) && devices.length > 0) {
    const newData = devices
      .map((device) => {
        const label = `${device.market_name} - Hasta ${parseInt(device?.price)} €`;
        const value = device.id;
        return {
          imageUrl: device?.image_url,
          label,
          value,
          price: parseFloat(device?.price),
          productName: device.market_name,
        };
      })
      .slice(0, 20);
    return newData;
  }
  return null;
};


const contextStore = (state) => state.main.context;


export function* getDevices({ payload }) {
  const contextApi = yield select(contextStore);
  try {
    const { data } = { ...payload };
    const { search, deviceKind } = { ...data };
    const keyText = ' - Hasta';
    let clearText = search;
    if(search && search.includes(keyText)){
      clearText = search.split(keyText)[0]
    }
    yield delay(300);
    const response = yield call(getDevicesPromise, {
      context: contextApi,
      search: clearText,
      deviceKind: deviceKind?.value
    });
    const devices = normalizeGetDevicesResponse(response);
    yield put(
      actions.setDevices({
        devices,
      })
    );
  } catch (error) {
    yield put(
      actions.setDevices({
        devices : [],
      })
    );
  }
}
